import { normalizeLexiconTrigramText } from './lexicon-trigram'
import { type LexiconHit } from './lexicon-model'

export function normalizeLexiconText(value: string): string {
  return normalizeLexiconTrigramText(value).trim()
}

export function lexiconMatchTier(hit: Pick<LexiconHit, 'headword'>, text: string): number {
  const headword = normalizeLexiconText(hit.headword)
  if (headword === text) return 0
  if (headword.startsWith(text)) return 1
  return headword.includes(text) ? 2 : 3
}
